import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ListChargesHeader from "./list-charges-header";
import ListChargesMisc from "./list-charges-misc";
import {
    approveMerchandiserInvoices,
    fetchMerchandiserInvoicingCharges,
    fetchMerchandiserPdfInvoice, submitMerchandiserInvoices
} from "../../../../api/menu/invoicing/actions";
import { deleteMiscChargeById } from "../../../../api/menu/master-files/misc-charges/actions";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import UserTypes from "../../../auth/user-types";
import Spinner from "../../../common/Spinner";
import MiscChargeModal from "./misc-charge-modal";

class MiscCharges extends React.Component {
    constructor(props) {
        super(props);

        this.handleEditMisc = this.handleEditMisc.bind(this);
        this.handleDeleteMisc = this.handleDeleteMisc.bind(this);
    }

    handleToggleSelectedMiscCharges = (chargeId = false, ref = null) => {
        let selectedMiscCharges = Object.assign({}, this.props.selectedMiscCharges);
        if (chargeId) {
            if (selectedMiscCharges[chargeId]) {
                delete selectedMiscCharges[chargeId];
            } else {
                selectedMiscCharges[chargeId] = true;
            }
        } else if (Object.keys(selectedMiscCharges).length) {
            selectedMiscCharges = {};
        } else {
            const { charges } = this.props;
            if (ref) {
                const data = ref.current.getResolvedState().sortedData;
                data.forEach(item => {
                    selectedMiscCharges[item._original.chargeId] = true;
                });
            } else {
                (charges && charges.miscCharges ? charges.miscCharges : []).forEach(item => {
                    selectedMiscCharges[item.chargeId] = true;
                });
            }
        }

        this.props.handleSelectMiscCharge(selectedMiscCharges);
    };

    handleEditMisc = (miscChargeId = false, merchandiserId = false) => {
        const modalObj = {
            id: "misc-charge-report",
            modalSettings: {
                size: "md",
                style: {
                    top: 20
                },
            },
            header: "Add/Edit Miscellaneous Charge",
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <MiscChargeModal
                        miscChargeId={miscChargeId}
                        merchandiserId={merchandiserId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => {
                            this.props.handleLoad();
                            this.props.closeCustomModal(modalObj);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleDeleteMisc = (chargeId) => {
        this.props.deleteMiscChargeById(chargeId, () => {
            this.props.handleLoad();
        });
    };

    render() {
        const {
            loading,
            charges,
            userRole
        } = this.props;

        const isAdminView = userRole ? userRole.includes(UserTypes.admin) : false;
        const isAccountManagerView = userRole ? userRole.includes(UserTypes.accountManager) : false;
        const isMerchandiserView = userRole ? userRole.includes(UserTypes.merchandiser) : false;

        return (
            <div className="position-relative">
                {!loading || <Spinner/>}

                <ListChargesHeader
                    handleLoad={this.props.handleLoad}
                    handleViewPreliminaryInvoice={this.props.handleViewPreliminaryInvoice}
                    handleSelect={this.props.handleSelect}
                    handleApprove={this.props.handleApprove}
                    handleSubmitInvoice={this.props.handleSubmitInvoice}
                    submitIsDisabled={!(charges && charges.miscCharges ? charges.miscCharges : []).length}
                    filters={this.props.filters}
                />
                <ListChargesMisc
                    userRole={userRole}
                    miscCharges={charges && charges.miscCharges ? charges.miscCharges : []}
                    onToggle={this.handleToggleSelectedMiscCharges}
                    isAdminView={isAdminView}
                    isAccountManagerView={isAccountManagerView}
                    isMerchandiserView={isMerchandiserView}
                    selectedMiscCharges={this.props.selectedMiscCharges}
                    onEdit={this.handleEditMisc}
                    onDelete={this.handleDeleteMisc}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    userRole: state.auth.user.role,
    loading: state.invoicing.loading,
    charges: state.invoicing.charges
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandiserInvoicingCharges:
        bindActionCreators(fetchMerchandiserInvoicingCharges, dispatch),
    fetchMerchandiserPdfInvoice: bindActionCreators(fetchMerchandiserPdfInvoice, dispatch),
    approveMerchandiserInvoices: bindActionCreators(approveMerchandiserInvoices, dispatch),
    submitMerchandiserInvoices: bindActionCreators(submitMerchandiserInvoices, dispatch),

    deleteMiscChargeById: bindActionCreators(deleteMiscChargeById, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MiscCharges);
